import { createAsyncThunk } from "@reduxjs/toolkit";
import { companySettingsSelector } from "../store/slice/settings";

export const streamSnapshotAction = createAsyncThunk(
  'realtime/StreamSnapshot',
  /**
   * 
   * @param {Partial<import("../..").ISnapshotData>} data 
   * @returns 
   */
  async (data, { getState }) => {
    const settings = companySettingsSelector(getState());
    return { ...data, usePrevCloseDayForMcap: settings.usePrevCloseDayForMcap };
  },
);

export const streamTradesAction = createAsyncThunk(
  'realtime/StreamTrades',
  /**
   * 
   * @param {Partial<import("../..").ITradesData>} data 
   * @returns 
   */
  async (data, { getState }) => {
    const settings = companySettingsSelector(getState());
    return { ...data, usePrevCloseDayForMcap: settings.usePrevCloseDayForMcap };
  },
);